import localStore from "./localstore.util";

export const setAdminInfo = async (info:any) => {
  const _data = { ...info };
  await localStore.store_data("Admininfo", _data);
  return true;
};
export const getAdminInfo = () => localStore.get_data("Admininfo");

export const getUserInfo = () => localStore.get_data("userinfo");
